module.exports = __webpack_public_path__ + "media/common/fonts/template/template-910e62e7d38228bda777e77a1a9694a5.eot";